import { forwardRef } from 'react'
import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from './cn'

export type BadgeVariant = 'neutral' | 'success' | 'warning' | 'danger' | 'info'
export type BadgeSize = 'sm' | 'md'

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant
  size?: BadgeSize
  children?: ReactNode
}

const BASE = 'inline-flex items-center font-medium rounded-full'

// 状態色トークンの淡色背景 + AA テキスト色（fg）で構成。
// 色は variant が確定（利用側 className での上書き対象外）。
const VARIANT: Record<BadgeVariant, string> = {
  neutral: 'bg-gray-100 text-gray-700',
  success: 'bg-success-bg text-success-fg',
  warning: 'bg-warning-bg text-warning-fg',
  danger: 'bg-danger-bg text-danger-fg',
  info: 'bg-info-bg text-info-fg',
}

const SIZE: Record<BadgeSize, string> = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-0.5 text-sm',
}

/** 状態・分類ラベル。色のみに依存せずテキストで意味を伝える。 */
export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  { variant = 'neutral', size = 'md', className, children, ...rest },
  ref,
) {
  return (
    <span ref={ref} className={cn(BASE, VARIANT[variant], SIZE[size], className)} {...rest}>
      {children}
    </span>
  )
})
